exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".high-light-campaign__container{display:flex;background-color:#FFF2DF;height:40px;padding:0px 16px;justify-content:space-between;align-items:center;color:#FF9B1A;border-radius:4px}.high-light-campaign__content{display:flex;justify-content:flex-start;align-items:center}.high-light-campaign__content:before{content:'';display:block;margin-right:8px;background:url(\"/assets/img/high-light-campaign-icon.svg\");width:24px;height:24px}\n", ""]);

// exports
